import moment from 'moment';
export default {
    async editJobAvaiability(context, par){

        if(par.body_availability_edit){
            let body_avaiabilty = {
                type: "availability_edit"
            }
            Object.assign(body_avaiabilty, par.body_availability_edit);

            return await this.$api.info.allApi(body_avaiabilty)
            .then( async () => {
                if(par.job_edit_body){

                    let body = {
                        type: "job_edit"
                    }
                    Object.assign(body, par.job_edit_body);
                    return await this.$api.info.allApi(body)
                    .then( () => {
                        context.state.current_work.turniInviati = 2
                        return true    
                    })

                } else {
                    context.state.current_work.turniInviati = 2
                    return true
                }  
            })
        } else {
            return true
        }

    },
    async newCandidatureDisp(context, par){
        let body = {
            type: "job_edit"
        }
        Object.assign(body, par);
        return await this.$api.info.allApi(body)
        .then( () => {
            context.state.current_work.disponibilita = par.disponibilita
            return true
        })
    },
    async confermaContratto(context, par){
        let body = {
            type: "job_edit"
        }
        Object.assign(body, par);
        return await this.$api.info.allApi(body)
        .then( () => {
            context.state.current_work.contrattoRicevuto = 1
            return true
        })
    },
    async ritiratiCandidatura(context, par){
        let body = {
            type: "job_edit"
        }
        Object.assign(body, par);
        return await this.$api.info.allApi(body)
        .then( () => {
            context.state.current_work.disponibilita = 4
            return true
        })
    },
    async loadWorks(context, filter = null){
        let body = {
            "type": "jobs_list"
        }

        Object.assign(body, filter);

        if(!body.dates || !body.dates[0] || Array.isArray(body.dates).length == 0 || moment(body.dates[0]).isBefore("2024-08-01")){
            body.dates = ["2024-08-01", "2060-01-01"]
        }

        return await this.$api.info.allApi(body)
        .then( response => {
            context.commit("jobs_list",response)
            return true
        })

        // setTimeout(() => context.commit("user",context.state.fake), 1000);
    },
    async loadCurrentWork(context, id){
        let body = {
            "type": "jobs_list",
            "id": id
        }
        return await this.$api.info.allApi(body)
        .then( (response) => {
            if(response && response.response && response.response.candidature && response.response.candidature.length)
                context.commit("current_work",response.response.candidature[0])
            return response.response.candidature[0]
        })
    },
    async loadDetailsWork(context, id){
        let body = {
            "type": "candidature_detail",
            "id": id
          }
        return await this.$api.info.allApi(body)
        .then( (response) => {
            if(response && response.response){
                if(response.response.turni && response.response.disponibilita){
                    context.commit("details_work",response.response)
                }
            }
            return true
        })
    },
}
